import { authApi } from "./api";
import {
  clearSession,
  getStaffUser,
  hasStoredSession,
  setStoredStaff,
  updateStoredStaff,
} from "./auth-storage";
import {
  invalidateClientSession,
  isPublicPath,
  notifySessionRestored,
  redirectToLoginOnce,
} from "./auth-events";
import {
  bootstrapAuthenticatedStaff,
  isAuthBootstrapComplete,
  markAuthBootstrapSettled,
  resetAuthBootstrapState,
  waitForAuthBootstrap,
} from "./auth-bootstrap";

export {
  hasStoredSession,
  getStaffUser,
  setStoredStaff,
  updateStoredStaff,
  clearSession,
  isPublicPath,
  invalidateClientSession,
  notifySessionRestored,
  redirectToLoginOnce,
};

/** True once GET /auth/staff/me has loaded a staff user in this tab. */
export function isAuthenticated(): boolean {
  return hasStoredSession();
}

/** Ends the staff session, then returns to the login screen. */
export async function logout(): Promise<void> {
  try {
    await authApi.logout();
  } catch {
    // Session may already be invalid; clearing client state below is enough.
  }
  resetAuthBootstrapState();
  invalidateClientSession();
  markAuthBootstrapSettled();
  window.location.assign("/login");
}

export {
  bootstrapAuthenticatedStaff,
  isAuthBootstrapComplete,
  markAuthBootstrapSettled,
  resetAuthBootstrapState,
  waitForAuthBootstrap,
};
